"use client";


import Header from "@aztk-hub/pkg-header";
import { PrismicNextLink } from "@prismicio/next";
import React from "react";


const Logo = () => (
  <PrismicNextLink href="/" aria-label="Accueil - YYP" title="Accueil">
    <div className="w-[143px] h-[24px]">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="143"
        height="24"
        viewBox="0 0 143 24"
        fill="none"
        role="img"
        aria-label="Logo YYP"
        focusable="false"
      >
        <path d="M30.7816 0.316755L17.2514 23.997H24.2507L29.8502 14.3365L34.7231 23.997H41.7224L33.3232 8.11702L37.8342 0.316755H30.7816Z" fill="white" />
        <path d="M17.4716 0.316755L11.8722 9.97727L6.9993 0.316755H0L8.39916 16.1967L3.88821 23.997H10.9381L24.4709 0.316755H17.4716Z" fill="#F1E146" />
        <path d="M64.9441 18.5843C64.7312 18.6827 64.4731 18.7306 64.1617 18.7306H56.6833V17.1817H64.1617C64.4731 17.1817 64.7312 17.227 64.9441 17.3201C65.1544 17.4133 65.2608 17.6235 65.2608 17.9535C65.2608 18.2835 65.1544 18.4831 64.9441 18.5816M67.5043 14.8318C66.9987 14.5524 66.4078 14.3608 65.7319 14.2517C65.0559 14.1425 64.332 14.0893 63.5576 14.0893H52.8111V24H56.6833V21.4451H63.5576C64.332 21.4451 65.0559 21.4079 65.7319 21.336C66.4078 21.2642 66.9987 21.1151 67.5043 20.8863C68.01 20.6574 68.4065 20.3141 68.6966 19.8484C68.9867 19.3826 69.1304 18.7546 69.1304 17.9588C69.1304 17.1631 68.9867 16.5138 68.6966 16.0081C68.4065 15.5025 68.01 15.1113 67.5043 14.8318Z" fill="white" />
        <path d="M77.3944 16.9128L79.5049 20.1729H75.3026L77.3971 16.9128H77.3944ZM75.2308 14.0865L68.5881 23.9972H72.8462L73.8096 22.4962H81.0085L81.9799 23.9972H86.238L79.5341 14.0865H75.2281H75.2308Z" fill="white" />
        <path d="M101.695 19.8564C101.586 20.0879 101.41 20.2822 101.168 20.4365C100.926 20.5909 100.604 20.708 100.199 20.7851C99.7971 20.8623 99.3048 20.9022 98.7273 20.9022H91.6029V17.1871H98.7273C99.3048 17.1871 99.7945 17.2243 100.199 17.3042C100.601 17.3813 100.923 17.4984 101.168 17.6528C101.41 17.8072 101.586 18.0014 101.695 18.233C101.804 18.4645 101.857 18.7359 101.857 19.0473C101.857 19.3587 101.804 19.6275 101.695 19.8617M104.476 15.5903C103.959 15.1246 103.246 14.76 102.339 14.4912C101.431 14.2224 100.279 14.0893 98.887 14.0893H87.7386V24H98.887C100.207 24 101.314 23.8669 102.208 23.5981C103.103 23.3293 103.818 22.9621 104.361 22.499C104.904 22.036 105.293 21.5064 105.53 20.9129C105.767 20.3194 105.886 19.6967 105.886 19.0473C105.886 18.398 105.78 17.7752 105.57 17.1817C105.359 16.5883 104.995 16.0587 104.478 15.5956" fill="white" />
        <path d="M108.018 14.0865V23.9972H123.659V21.0564H111.891V19.8163H121.49V18.2674H111.891V17.0299H123.627V14.0865H108.018Z" fill="white" />
        <path d="M125.929 14.0865V23.9972H138.828V21.0564H129.801V14.0865H125.929Z" fill="white" />
        <path d="M61.6016 6.08113V7.32662H72.4465V10.286H57.9077V0.316755H72.4465V3.27612H61.6016V4.52427H69.9609V6.08113H61.6016Z" fill="white" />
        <path d="M73.9657 6.63462H78.2185C78.2904 6.85284 78.5033 7.03647 78.8573 7.18817C79.2112 7.33986 79.6849 7.4543 80.2837 7.53148C80.8799 7.60865 81.5745 7.64857 82.3649 7.64857C83.1553 7.64857 83.7594 7.62462 84.2119 7.57938C84.6643 7.53148 84.9836 7.44898 85.1699 7.32922C85.3562 7.20946 85.4494 7.04712 85.4494 6.83954C85.4494 6.6426 85.2977 6.48825 84.997 6.37913C84.6962 6.27002 84.1613 6.1955 83.3922 6.15292C82.623 6.11034 81.5425 6.09171 80.1507 6.09171C79.1128 6.09171 78.2159 6.04115 77.4627 5.94268C76.7096 5.84421 76.0921 5.68986 75.6078 5.47429C75.1261 5.26139 74.7695 4.9926 74.5406 4.66526C74.3117 4.33792 74.1973 3.94671 74.1973 3.48896C74.1973 2.70122 74.4661 2.0492 74.9983 1.53291C75.5333 1.01928 76.345 0.633387 77.4281 0.380564C78.5139 0.125079 79.8712 -1.90735e-06 81.5026 -1.90735e-06C83.8898 -1.90735e-06 85.7155 0.345967 86.9797 1.03524C88.2411 1.72718 88.8719 2.71985 88.8719 4.01856H84.8373C84.784 3.67525 84.462 3.41445 83.8712 3.23082C83.2777 3.04985 82.4368 2.9567 81.3483 2.9567C80.2598 2.9567 79.4667 3.01791 78.9424 3.14299C78.4181 3.26807 78.1547 3.48098 78.1547 3.7817C78.1547 3.93872 78.2265 4.06114 78.3729 4.15695C78.5193 4.25009 78.7694 4.32461 79.1287 4.38316C79.488 4.44171 79.9937 4.47897 80.6483 4.50026C81.303 4.52155 82.1334 4.53219 83.142 4.53219C84.2518 4.53219 85.1992 4.58542 85.9763 4.69453C86.7561 4.80364 87.3868 4.96864 87.8685 5.18421C88.3502 5.40244 88.7015 5.67921 88.9198 6.0172C89.138 6.35518 89.2471 6.75172 89.2471 7.20946C89.2471 7.99987 88.9996 8.6439 88.4993 9.14156C88.0016 9.63923 87.2112 10.0091 86.1307 10.2487C85.0502 10.4882 83.637 10.6079 81.8938 10.6079C80.9065 10.6079 80.0016 10.5521 79.174 10.4376C78.3489 10.3232 77.6144 10.1555 76.9704 9.93197C76.3263 9.70842 75.7808 9.43431 75.3337 9.10697C74.8866 8.77963 74.5459 8.41237 74.3144 7.99987C74.0802 7.59003 73.9631 7.13494 73.9631 6.63728" fill="white" />
        <path d="M52.3851 0.316755L49.0398 4.83032L45.6972 0.316755H41.3992L47.0545 7.7471V10.286H51.0252V7.7471L56.6832 0.316755H52.3851Z" fill="white" />
        <path d="M115.063 6.08113V7.32662H125.908V10.286H111.369V0.316755H125.908V3.27612H115.063V4.52427H123.423V6.08113H115.063Z" fill="white" />
        <path d="M127.425 6.63462H131.678C131.749 6.85284 131.962 7.03647 132.316 7.18817C132.67 7.33986 133.144 7.4543 133.743 7.53148C134.339 7.60865 135.033 7.64857 135.824 7.64857C136.614 7.64857 137.218 7.62462 137.671 7.57938C138.123 7.53148 138.443 7.44898 138.629 7.32922C138.815 7.20946 138.908 7.04712 138.908 6.83954C138.908 6.6426 138.759 6.48825 138.456 6.37913C138.155 6.27002 137.62 6.1955 136.851 6.15292C136.082 6.11034 135.002 6.09171 133.61 6.09171C132.572 6.09171 131.675 6.04115 130.922 5.94268C130.169 5.84421 129.551 5.68986 129.069 5.47429C128.588 5.26139 128.231 4.9926 128.002 4.66526C127.773 4.33792 127.659 3.94671 127.659 3.48896C127.659 2.70122 127.928 2.0492 128.46 1.53291C128.995 1.01928 129.807 0.633387 130.89 0.380564C131.976 0.125079 133.333 -1.90735e-06 134.964 -1.90735e-06C137.352 -1.90735e-06 139.177 0.345967 140.441 1.03524C141.703 1.72718 142.334 2.71985 142.334 4.01856H138.299C138.246 3.67525 137.924 3.41445 137.333 3.23082C136.739 3.04985 135.898 2.9567 134.81 2.9567C133.721 2.9567 132.928 3.01791 132.404 3.14299C131.88 3.26807 131.616 3.48098 131.616 3.7817C131.616 3.93872 131.688 4.06114 131.835 4.15695C131.978 4.25009 132.231 4.32461 132.59 4.38316C132.95 4.44171 133.455 4.47897 134.11 4.50026C134.765 4.52155 135.595 4.53219 136.604 4.53219C137.713 4.53219 138.661 4.58542 139.438 4.69453C140.218 4.80364 140.849 4.96864 141.33 5.18421C141.812 5.40244 142.163 5.67921 142.381 6.0172C142.6 6.35518 142.709 6.75172 142.709 7.20946C142.709 7.99987 142.461 8.6439 141.961 9.14156C141.463 9.63923 140.673 10.0091 139.592 10.2487C138.512 10.4882 137.099 10.6079 135.356 10.6079C134.368 10.6079 133.463 10.5521 132.636 10.4376C131.811 10.3232 131.076 10.1555 130.432 9.93197C129.788 9.70842 129.242 9.43431 128.795 9.10697C128.348 8.77963 128.008 8.41237 127.776 7.99987C127.542 7.59003 127.425 7.13494 127.425 6.63728" fill="white" />
        <path d="M105.847 0.316755L102.501 4.83032L99.1562 0.316755H94.8608L100.516 7.7471V10.286H104.487V7.7471L110.142 0.316755H105.847Z" fill="white" />
      </svg>
    </div>
  </PrismicNextLink>
);

const DesktopNavComponent = ({ items }) => (
  <ul
    className="flex flex-row gap-10 items-center text-white"
    aria-label="Navigation principale"
  >
    {items.map((item) => (
      <li key={item.id}>
        {item.variant == "Primary" && (
          <PrismicNextLink
            field={item}
            className="text-menu-item no-underline"
            title={item.text}
            aria-label={item.text}
          >
            {item.text}
          </PrismicNextLink>
        )}
        {item.variant == "Secondary" && (
          <PrismicNextLink
            field={item}
            className="bg-yellow text-dark-green cta-text cta px-4 py-2.5 block no-underline"
            title={item.text}
            aria-label={item.text}
          >
            {item.text}
          </PrismicNextLink>
        )}
      </li>
    ))}
  </ul>
);

const MobileNavComponent = ({ items }) => (
  <ul
    className="flex flex-col gap-10 items-end no-underline px-4"
    aria-label="Navigation mobile"
  >
    {items.map((item) => (
      <li key={item.id}>
        {item.variant == "Primary" && (
          <PrismicNextLink
            field={item}
            className="text-menu-item text-white no-underline"
            title={item.text}
            aria-label={item.text}
          >
            {item.text}
          </PrismicNextLink>
        )}
        {item.variant == "Secondary" && (
          <PrismicNextLink
            field={item}
            className="bg-yellow text-dark-green cta-text cta px-4 py-2.5 block no-underline"
            title={item.text}
            aria-label={item.text}
          >
            {item.text}
          </PrismicNextLink>
        )}
      </li>
    ))}
  </ul>
);

const BurgerIcon = () => <svg width="24" height="10" viewBox="0 0 24 10" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M24 10H0V8H24V10ZM24 2H0V1.90735e-06H24V2Z" fill="white" />
</svg>

const CloseIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
  <path d="M20.7089 1.32069L12.0295 10L20.7089 18.6793L19.3882 20L10.7089 11.3207L2.02955 20L0.708862 18.6793L9.38818 10L0.708862 1.32069L2.02955 0L10.7089 8.67931L19.3882 0L20.7089 1.32069Z" fill="white" />
</svg>

export default function CHeader({ header }) {
  return (
    <Header
      breakpoint="lg"
      LogoComponent={Logo}
      DesktopMainNavComponent={DesktopNavComponent}
      MobileMainNavComponent={MobileNavComponent}
      mainNavItems={header.data.menu_items}
      hasLogoMobileOpenMenu={true}
      BurgerIcon={BurgerIcon}
      CloseIcon={CloseIcon}
    />
  );
}
